module.exports = __webpack_public_path__ + "static/media/dark-motion-orbit-phasing.aab98c7.mp4";